'use client';

import { Provider } from 'react-redux';
import createStore, { PreloadedRootState } from 'src/redux/store';

type ProvidersProps = {
  children?: React.ReactNode;
  initialReduxState: PreloadedRootState;
};

const Providers: React.FC<ProvidersProps> = ({
  initialReduxState,
  children,
}) => <Provider store={createStore(initialReduxState)}>{children}</Provider>;

export default Providers;
